import { useQuery } from '@apollo/client';
import invariant from 'tiny-invariant';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { CollapsibleCard } from '~/components/ui/collapse';
import { SupplementalDocumentList } from '~/components/upload/supporting-object/supplemental-documents/supplemental-document-list';
import { SupplementalDocumentUploader } from '~/components/upload/supporting-object/supplemental-documents/supplemental-document-uploader';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const UPLOAD_STUDY_SUPPLEMENTAL_DOCS_PAGE = graphql(`
  query UploadStudySupplementalDocsPage($id: ID!) {
    studyGet(id: $id) {
      id
      supplementalDocuments {
        ...supplementalDocumentParts
        file {
          ...fileParts
        }
      }
    }
  }
`);

export default function UploadStudySupplementalDocumentsPage() {
  return (
    <ApolloProviderV4>
      <UploadStudySupplementalDocumentsPageInner />
    </ApolloProviderV4>
  );
}

function UploadStudySupplementalDocumentsPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(UPLOAD_STUDY_SUPPLEMENTAL_DOCS_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: UPLOAD_STUDY_SUPPLEMENTAL_DOCS_PAGE,
      variables: { id: studyId },
    },
  ]);

  const docs = data?.studyGet?.supplementalDocuments;

  if (loading) return <SpinnerPlaceholder />;
  invariant(docs, 'Error loading supplemental documents!');

  return (
    <div className="space-y-4">
      <CollapsibleCard title="Upload Supplemental Documents">
        <SupplementalDocumentUploader
          studyId={studyId}
          refetchQueries={refetchQueries}
        />
      </CollapsibleCard>

      <SupplementalDocumentList
        supplementalDocuments={docs}
        refetchQueries={refetchQueries}
      />
    </div>
  );
}
